var map = {
	"./site-logo-desktop-alt.svg": 74235,
	"./site-logo-desktop-footer.svg": 22095,
	"./site-logo-desktop.svg": 21049,
	"./site-logo-drawer-mobile.svg": 98027,
	"./site-logo-drawer.svg": 99560,
	"./site-logo-mobile-drawer.svg": 95605,
	"./site-logo-mobile.svg": 7389,
	"./site-logo-sm.svg": 70207,
	"./site-logo-tv.svg": 41845,
	"./site-logo-wrapper-mobile-scrolled.svg": 32144,
	"./site-logo-wrapper-mobile.svg": 89791,
	"./site-logo-wrapper-scrolled.svg": 97305,
	"./site-logo-wrapper.svg": 1292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96976;